import NotificationManager from './NotificationManager';

export default NotificationManager;